'use strict';

var PaymentMethodModel = require('bunsen/models/ecomm/PaymentMethodModel');
var CreditCard = module.exports = PaymentMethodModel.extend();
var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');
var Address = require('bunsen/models/Address');
var creditCardMixin = require('bunsen/models/mixins/ecomm/creditCardMixin');
var ends = require('dibs-endpoints');
var Token = require('bunsen/models/ecomm/Token');
var braintree;
var cardTypeMap;

require('bunsen/libraries/plugins/jquery.payment');

// braintree can only be used in a browser
if (typeof window !== 'undefined') {
    braintree = window.braintree;
}


// jquery-payment card types mapped to service types
cardTypeMap = {
    visa:  PaymentMethodModel.CARD_TYPE_VISA,
    mastercard:  PaymentMethodModel.CARD_TYPE_MASTER,
    discover:  PaymentMethodModel.CARD_TYPE_DISCOVER,
    amex:  PaymentMethodModel.CARD_TYPE_AMEX
};

_.extend(CreditCard.prototype, {
    idAttribute: "token",
    defaults : {
        apiType : 'creditCard',
        paymentMethodType : PaymentMethodModel.TYPE_CREDIT_CARD,
        billingAddress: {}
    },
    url: function () {
        return ends.savedCard(this.getUserId(), this.get('hashedCardNumber'));
    },
    relations: [
        {
            type: Backbone.One,
            key: 'billingAddress',
            relatedModel: Address
        }
    ],
    getDisplayVal: function () {
        return 'Credit Card';
    },
    getLastNumbers: function () {
        var maskedCardNumber = this.get('maskedCardNumber');
        return maskedCardNumber.substr(-4);
    },
    getCardType: function () {
        var maskedCardNumber = this.get('maskedCardNumber');
        var jqueryPaymentCardType = maskedCardNumber && $.payment.cardType(maskedCardNumber);
        return cardTypeMap[jqueryPaymentCardType];
    },
    updateMaskedCardNumber : function () {
        var ccN = this.get('creditCardNumber') || '';
        this.set('maskedCardNumber', ccN.replace(/[^0-9]/g, '').replace(/^(\d{6})\d+(\d{4})$/, '$1******$2'));
    },
    makeNewCard: function () {
        return new CreditCard(this.omit('id', 'token', 'cardType'));
    },
    removeSpacesFromCreditCard: function () {
        var number = this.get('creditCardNumber');
        this.set('creditCardNumber', number.replace(/ /g, ''));
    },
    deleteFromWallet: function (userId, options) {
        var url = ends.savedCard(userId, this.get('hashedCardNumber'));
        options = _.extend({url: url}, options);
        return this.destroy(options);
    },
    saveToVault: function (userId, options) {
        var vaultRequest;
        options = _.extend({
            url: ends.vault(userId)
        }, options);

        options.queries = _.extend({
            paymentMethodNonce: this.get('nonce')
        }, options.queries);

        vaultRequest = new SoaModel();
        return vaultRequest.save({}, options);
    },
    saveToSellerVault : function (sellerId, options) {
      var vaultRequest;
      options = _.extend({
          url: ends.sellerVault(sellerId)
      }, options);

      options.queries = _.extend({
          paymentMethodNonce: this.get('nonce')
      }, options.queries);

      vaultRequest = new SoaModel();
      return vaultRequest.save({}, options);
    },
    setNonce: function (options) {
    // this method only works in the browser due to braintree-web limitations
        var clientToken = new Token();
        options = options || { validate : true };
        return clientToken.fetchClientToken().then(function () {
            var def = $.Deferred();
            var client = new braintree.api.Client({clientToken: clientToken.get('value')});
            var tokenizeObject = {
                number: this.get('creditCardNumber'),
                cardholderName: this.get('cardHolderName'),
                expirationMonth: this.get('cardExpiryMonth'),
                expirationYear: this.get('cardExpiryYear'),
                // Address if AVS is on
                billingAddress: {
                    firstName: this.get('billingAddress.firstName') || null,
                    lastName: this.get('billingAddress.lastName') || null,
                    company: this.get('billingAddress.company') || null,
                    streetAddress: this.get('billingAddress.line1'),
                    extendedAddress: this.get('billingAddress.line2') || null,
                    locality: this.get('billingAddress.city'),
                    region: this.get('billingAddress.state'),
                    postalCode: this.get('billingAddress.zipCode'),
                    countryCodeAlpha2: this.get('billingAddress.country')
                }
            };

            if (options.validate) {
                tokenizeObject.cvv = this.get('securityCode')
            }

            client.tokenizeCard(tokenizeObject, function (err, nonce) {
                if (err) {
                    def.reject(err);
                    return;
                }
                this.set('nonce', nonce);
                def.resolve(nonce);
            }.bind(this));

            return def.promise();
        }.bind(this));

    }
}, creditCardMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/payment-methods/CreditCard.js
// module id = 186
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55